/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Card_DescriptionInputs */

const en_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the same method you used to create your account.`)
};

const de_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie dieselbe Methode, mit der Sie Ihr Konto erstellt haben.`)
};

const pt_br2_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o mesmo método que você usou para criar sua conta.`)
};

const tr_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınızı oluştururken kullandığınız yöntemi kullanın.`)
};

const zh_cn2_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请使用创建账户时所用的方式。`)
};

const zh_hk2_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請使用建立帳戶時所用的方式。`)
};

const ko_kr2_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정을 만들 때 사용한 방법으로 로그인하세요.`)
};

const ru_ru2_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте тот же способ, которым вы создавали аккаунт.`)
};

const es_419_login_page_card_description = /** @type {(inputs: Login_Page_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa el mismo método que utilizaste para crear tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Use the same method you used to create your account." |
*
* @param {Login_Page_Card_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_card_description = /** @type {((inputs?: Login_Page_Card_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Card_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_card_description(inputs)
	if (locale === "de") return de_login_page_card_description(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_card_description(inputs)
	if (locale === "tr") return tr_login_page_card_description(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_card_description(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_card_description(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_card_description(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_card_description(inputs)
	return es_419_login_page_card_description(inputs)
});